module.exports = __webpack_public_path__ + "static/media/pdf_logo.d63479ea.png";